module.exports = __webpack_public_path__ + "static/media/rod.9ec5513d.fbx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/rod.fbx
// module id = 177
// module chunks = 0